import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { API, api } from "../lib/api";
import { Volume2, VolumeX, ArrowRight, Play } from "lucide-react";

export default function HeroPromo() {
  const [item, setItem] = useState(null);
  const [muted, setMuted] = useState(true);
  const ref = useRef(null);
  useEffect(() => {
    api.get("/learn/promo").then((r) => { const lang = localStorage.getItem("raq_lang") || "en"; const list = r.data.items || []; setItem(list.find((x) => x.lang === lang) || list[0] || null); }).catch(() => {});
  }, []);
  if (!item) return null;
  const toggle = () => { const v = ref.current; if (!v) return; v.muted = !v.muted; setMuted(v.muted); if (!v.muted) { v.currentTime = 0; v.play().catch(() => {}); } };
  return (
    <div className="glass rounded-3xl p-3 relative overflow-hidden" data-testid="hero-promo">
      <div className="relative rounded-2xl overflow-hidden border border-slate-800 bg-black">
        <video ref={ref} src={`${API}/learn/media/${item.video}`} poster={`${API}/learn/media/${item.poster}`} autoPlay muted loop playsInline preload="metadata" className="w-full aspect-video" data-testid="hero-promo-video" />
        <button onClick={toggle} data-testid="hero-promo-sound" className="absolute bottom-3 left-3 h-9 px-3 rounded-full bg-[#0B0D12]/85 backdrop-blur border border-slate-700 text-xs font-semibold text-white flex items-center gap-1.5 hover:border-cyan-400">
          {muted ? <><VolumeX className="w-3.5 h-3.5" />Tap for sound</> : <><Volume2 className="w-3.5 h-3.5 text-cyan-300" />Sound on</>}
        </button>
        <span className="absolute top-3 left-3 text-[10px] font-mono tracking-widest uppercase bg-[#0B0D12]/85 text-cyan-300 px-2 py-1 rounded">{Math.round(item.duration)}s · with Raq</span>
      </div>
      <div className="flex items-center justify-between gap-3 px-2 pt-3 pb-1">
        <div className="min-w-0"><p className="font-display font-bold text-sm sm:text-base truncate">See how selling your car works</p><p className="text-xs text-slate-400">Instant AI offer · guaranteed price · free pickup</p></div>
        <Link to="/sell" data-testid="hero-promo-cta" className="shrink-0 h-9 px-3 rounded-full bg-cyan-400 text-slate-950 text-xs font-semibold flex items-center gap-1.5 hover:bg-cyan-300"><Play className="w-3.5 h-3.5" />Get my offer<ArrowRight className="w-3.5 h-3.5" /></Link>
      </div>
    </div>
  );
}
